module.exports = __webpack_public_path__ + "static/media/contract-garanties-icon.a27ea578.svg";